import { AvatarSkeleton } from "@circleco/compass/components/AvatarSkeleton";
import { TypographySkeleton } from "@circleco/compass/components/TypographySkeleton";

const ROW_COUNT = 8;

export const RailMemberList = () => (
  <div className="flex w-full flex-col" data-testid="rail-member-list-loader">
    <div className="border-primary flex h-14 items-center justify-between border-b px-5">
      <TypographySkeleton variant="heading-md" className="w-24" />
    </div>
    <div className="flex flex-col px-6 pt-2">
      <div className="-mx-2 flex flex-col gap-0.5">
        {Array.from({ length: ROW_COUNT }, (_, index) => (
          <div key={index} className="flex h-10 items-center gap-3 px-3">
            <AvatarSkeleton size="sm" />
            <TypographySkeleton variant="label-sm" className="w-32" />
          </div>
        ))}
      </div>
    </div>
  </div>
);
